import React, { useState } from 'react';
import Header from '../components/Header/Header';
import SearchResultsHeader from '../components/SearchResultsHeader/SearchResultsHeader';
import FiltersSidebar from '../components/FiltersSidebar/FiltersSidebar';
import SortingOptions from '../components/SortingOptions/SortingOptions';
import PropertyCard from '../components/PropertyCard/PropertyCard';
import Pagination from '../components/Pagination/Pagination';
import MobileFilters from '../components/MobileFilters/MobileFilters';
import Footer from '../components/Footer/Footer';
import './PropertyListings.css';

function PropertyListings() {
  const [filters, setFilters] = useState({
    cities: [],
    propertyTypes: [],
    priceMin: '',
    priceMax: '',
    areaMin: '',
    areaMax: '',
    beds: null,
    baths: null
  });

  const [currentSort, setCurrentSort] = useState('latest');
  const [currentPage, setCurrentPage] = useState(1);
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);

  const mockProperties = [
    {
      id: 1,
      images: [
        'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=500',
        'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500',
        'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=500'
      ],
      price: 'PKR 1.5 Crore',
      pricePerSqft: 'PKR 30,000/sq ft',
      title: 'Luxury 5 Bedroom Villa in DHA',
      location: 'DHA Phase 6, Karachi',
      beds: 5,
      baths: 6,
      area: '500 sq yd',
      type: 'House',
      postedDate: '2 days ago',
      featured: true,
      verified: true
    },
    {
      id: 2,
      images: [
        'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500',
        'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=500'
      ],
      price: 'PKR 85 Lac',
      pricePerSqft: 'PKR 47,222/sq ft',
      title: 'Modern 3 Bedroom Apartment',
      location: 'Bahria Town, Lahore',
      beds: 3,
      baths: 3,
      area: '1800 sq ft',
      type: 'Flat',
      postedDate: '5 days ago',
      featured: false,
      verified: true
    },
    {
      id: 3,
      images: [
        'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=500',
        'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=500',
        'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=500'
      ],
      price: 'PKR 2.2 Crore',
      pricePerSqft: 'PKR 36,667/sq ft',
      title: 'Contemporary 6 Bedroom House',
      location: 'F-7, Islamabad',
      beds: 6,
      baths: 7,
      area: '600 sq yd',
      type: 'House',
      postedDate: '1 week ago',
      featured: true,
      verified: false
    },
    {
      id: 4,
      images: [
        'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=500'
      ],
      price: 'PKR 65 Lac',
      pricePerSqft: 'PKR 54,167/sq ft',
      title: 'Cozy 2 Bedroom Flat',
      location: 'Gulberg, Lahore',
      beds: 2,
      baths: 2,
      area: '1200 sq ft',
      type: 'Flat',
      postedDate: '3 days ago',
      featured: false,
      verified: true
    },
    {
      id: 5,
      images: [
        'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=500',
        'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=500'
      ],
      price: 'PKR 1.8 Crore',
      pricePerSqft: 'PKR 32,727/sq ft',
      title: 'Spacious Bungalow with Garden',
      location: 'Clifton, Karachi',
      beds: 5,
      baths: 5,
      area: '550 sq yd',
      type: 'House',
      postedDate: '1 day ago',
      featured: true,
      verified: true
    },
    {
      id: 6,
      images: [
        'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=500',
        'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=500'
      ],
      price: 'PKR 95 Lac',
      pricePerSqft: 'PKR 38,000/sq ft',
      title: 'Elegant 4 Bedroom Residence',
      location: 'DHA Phase 5, Lahore',
      beds: 4,
      baths: 4,
      area: '10 Marla',
      type: 'House',
      postedDate: '4 days ago',
      featured: false,
      verified: false
    },
    {
      id: 7,
      images: [
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZYxfedxebAwtaWmpelUvQ2uPAtyn5GjhTHg&s',
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-c7PcRKCVYHCgQT1fbfiuDQuA0wPeNYqMRA&s'
      ],
      price: 'PKR 1.2 Crore',
      title: 'Premium Villa with Pool',
      location: 'Bahria Town, Islamabad',
      beds: 4,
      baths: 5,
      area: '1 Kanal',
      type: 'House',
      postedDate: '6 days ago',
      featured: false,
      verified: true
    },
    {
      id: 8,
      images: [
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTR9mnuNUXJzJcLHuOx5DOcoTMbdb06U5vUsQ&s',
        'https://i.pinimg.com/736x/29/8b/d1/298bd1306fb4bd6f1b6dde36356b27fe.jpg'
      ],
      price: 'PKR 75 Lac',
      pricePerSqft: 'PKR 50,000/sq ft',
      title: 'Modern 3 Bedroom Flat',
      location: 'Gulistan-e-Jauhar, Karachi',
      beds: 3,
      baths: 3,
      area: '1500 sq ft',
      type: 'Flat',
      postedDate: '2 weeks ago',
      featured: false,
      verified: true
    }
  ];

  const handleFilterChange = (filterType, value, checked) => {
    if (filterType === 'reset') {
      setFilters({
        cities: [],
        propertyTypes: [],
        priceMin: '',
        priceMax: '',
        areaMin: '',
        areaMax: '',
        beds: null,
        baths: null
      });
      return;
    }

    if (filterType === 'city') {
      setFilters(prev => ({
        ...prev,
        cities: checked
          ? [...prev.cities, value]
          : prev.cities.filter(c => c !== value)
      }));
    } else if (filterType === 'propertyType') {
      setFilters(prev => ({
        ...prev,
        propertyTypes: checked
          ? [...prev.propertyTypes, value]
          : prev.propertyTypes.filter(t => t !== value)
      }));
    } else if (filterType === 'beds' || filterType === 'baths') {
      setFilters(prev => ({
        ...prev,
        [filterType]: prev[filterType] === value ? null : value
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        [filterType]: value
      }));
    }
  };

  const handleFilterTagRemove = (type, value) => {
    if (type === 'all') {
      handleFilterChange('reset');
      return;
    }

    if (type === 'city') {
      handleFilterChange('city', value, false);
    } else if (type === 'propertyType') {
      handleFilterChange('propertyType', value, false);
    } else if (type === 'price') {
      setFilters(prev => ({ ...prev, priceMin: '', priceMax: '' }));
    } else if (type === 'area') {
      setFilters(prev => ({ ...prev, areaMin: '', areaMax: '' }));
    } else if (type === 'beds' || type === 'baths') {
      setFilters(prev => ({ ...prev, [type]: null }));
    }
  };

  return (
    <div className="property-listings-page">
      <Header />

      <div className="listings-container">
        <div className="listings-content">
          <FiltersSidebar
            filters={filters}
            onFilterChange={handleFilterChange}
          />

          <div className="listings-main">
            <SearchResultsHeader
              totalResults={mockProperties.length}
              filters={filters}
              onFilterTagRemove={handleFilterTagRemove}
              onMobileFiltersOpen={() => setIsMobileFiltersOpen(true)}
            />

            <SortingOptions
              currentSort={currentSort}
              onSortChange={setCurrentSort}
            />

            <div className="properties-list">
              {mockProperties.map(property => (
                <PropertyCard key={property.id} property={property} />
              ))}
            </div>

            <Pagination
              currentPage={currentPage}
              totalPages={10}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>

      <MobileFilters
        isOpen={isMobileFiltersOpen}
        onClose={() => setIsMobileFiltersOpen(false)}
        filters={filters}
        onFilterChange={handleFilterChange}
      />

      <Footer />
    </div>
  );
}

export default PropertyListings;
